import { BrowserRouter, Routes, Route } from "react-router-dom"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { AuthProvider } from "./lib/auth-context"
import { ThemeProvider } from "./lib/theme-provider"
import { ToastProvider } from "./components/ui"
import { AuthGate } from "./components/auth-gate"
import { AdminLayout } from "./components/layout"
import { DashboardPage } from "./pages/dashboard"
import { UsersPage } from "./pages/users"
import { ServicesPage } from "./pages/services"
import { ReportsPage } from "./pages/reports"
import { SupportPage } from "./pages/support"
import { ContentEditorPage } from "./pages/content"
import { AdBannerPage } from "./pages/ad-banner"
import { AppConfigPage } from "./pages/app-config"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1 },
  },
})

export default function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <AuthProvider>
            <BrowserRouter>
              <AuthGate>
                <AdminLayout>
                  <Routes>
                    <Route path="/" element={<DashboardPage />} />
                    <Route path="/users" element={<UsersPage />} />
                    <Route path="/services" element={<ServicesPage />} />
                    <Route path="/reports" element={<ReportsPage />} />
                    <Route path="/support" element={<SupportPage />} />
                    <Route path="/content" element={<ContentEditorPage />} />
                    <Route path="/ad-banner" element={<AdBannerPage />} />
                    <Route path="/app-config" element={<AppConfigPage />} />
                  </Routes>
                </AdminLayout>
              </AuthGate>
            </BrowserRouter>
          </AuthProvider>
        </ToastProvider>
      </QueryClientProvider>
    </ThemeProvider>
  )
}
